import { shopCLient } from '@/services/axiosConfig'
import { Cart } from '@/types/data-types'

export interface CalculateCartReq {
  localCartItems: Array<{
    productId: number
    quantity: number
  }>
}

export type CalculateCartRes = Cart

interface ApiResp {
  carts: {
    calculateCart: CalculateCartRes
  }
}

type CalculateCart = (req: CalculateCartReq) => Promise<CalculateCartRes>

export const calculateCart: CalculateCart = async (req) => {
  try {
    const res = await shopCLient.post('/cart/calculate', req)
    return res.data
  } catch (e) {
    console.error(e)
  }
}
